import * as Types from '@Global/apollo/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBettingGamesQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  lifecycle?: Types.InputMaybe<Array<Types.GameLifecycleStage> | Types.GameLifecycleStage>;
  hasGiftToClaim?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  labels?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  myOwn?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetBettingGamesQuery = { __typename?: 'Query', bettingGames: { __typename?: 'BettingGameConnection', edges: Array<{ __typename?: 'BettingGameEdge', cursor: any, node: { __typename?: 'BettingGame', id: string, name: string, isStarted: boolean, isCompleted: boolean, isCanceled: boolean, acceptedCurrencies: Array<Types.Currency>, rake?: number | undefined, labels: Array<string>, completedAt?: any | undefined, betsNum?: number | undefined, period: { __typename?: 'DateInterval', from: any, to: any }, myGifts: Array<{ __typename?: 'CommonPack', id: string, isClaimed: boolean, expiresAt?: any | undefined, size: number } | { __typename?: 'MoneyReward', id: string, isClaimed: boolean, expiresAt?: any | undefined, rewardSum: { __typename?: 'Money', amount: number, currency: Types.Currency } } | { __typename?: 'NftCardGiveaway', id: string, isClaimed: boolean, expiresAt?: any | undefined, rewardedCard?: { __typename?: 'Card', id: string, image?: any | undefined } | undefined } | { __typename?: 'SeasonTicketReward', id: string, isClaimed: boolean, expiresAt?: any | undefined, gameFilter: { __typename?: 'GameFilter', isPaid?: boolean | undefined, isNft?: boolean | undefined, labels?: Array<string> | undefined } }>, myBets: Array<{ __typename?: 'UserBet', id: string, sum: { __typename?: 'Money', amount: number, currency: Types.Currency }, outcome: { __typename?: 'BettingGameOutcome', id: string } }>, outcomes: Array<{ __typename?: 'BettingGameOutcome', id: string, betsNum?: number | undefined, result?: number | undefined, subject: { __typename?: 'PlayerCardBettingGame', card: { __typename?: 'Card', id: string, image?: any | undefined, multiplier: number, rarity: Types.Rarity, tier: number, player: { __typename?: 'Player', id: string, name: string, photo?: any | undefined } } }, poolSum?: { __typename?: 'Money', amount: number, currency: Types.Currency } | undefined }>, jackpot?: { __typename?: 'Jackpot', id: string, isCompleted: boolean, guarantee: { __typename?: 'Money', amount: number, currency: Types.Currency }, poolSum?: { __typename?: 'Money', amount: number, currency: Types.Currency } | undefined } | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: any | undefined } } };


export const GetBettingGamesDocument = gql`
    query getBettingGames($first: Int = 3, $lifecycle: [GameLifecycleStage!], $hasGiftToClaim: Boolean, $labels: [String!], $after: Cursor, $myOwn: Boolean) {
  bettingGames(
    first: $first
    lifecycle: $lifecycle
    hasGiftToClaim: $hasGiftToClaim
    labels: $labels
    after: $after
    myOwn: $myOwn
  ) {
    edges {
      cursor
      node {
        id
        name(locale: RU)
        period {
          from
          to
        }
        myGifts {
          ... on CommonPack {
            id
            isClaimed
            expiresAt
            size
          }
          ... on MoneyReward {
            id
            isClaimed
            expiresAt
            rewardSum {
              amount
              currency
            }
          }
          ... on NftCardGiveaway {
            id
            isClaimed
            expiresAt
            rewardedCard {
              id
              image
            }
          }
          ... on SeasonTicketReward {
            id
            isClaimed
            expiresAt
            gameFilter {
              isPaid
              isNft
              labels
            }
          }
        }
        isStarted
        isCompleted
        isCanceled
        myBets {
          id
          sum {
            amount
            currency
          }
          outcome {
            id
          }
        }
        outcomes {
          id
          subject {
            ... on PlayerCardBettingGame {
              card {
                id
                image
                multiplier
                rarity
                tier
                player {
                  id
                  name(locale: RU)
                  photo
                }
              }
            }
          }
          betsNum
          result
          poolSum {
            amount
            currency
          }
        }
        acceptedCurrencies
        rake
        labels
        completedAt
        jackpot {
          id
          guarantee {
            amount
            currency
          }
          isCompleted
          poolSum {
            amount
            currency
          }
        }
        betsNum
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetBettingGamesQuery__
 *
 * To run a query within a React component, call `useGetBettingGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBettingGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBettingGamesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      lifecycle: // value for 'lifecycle'
 *      hasGiftToClaim: // value for 'hasGiftToClaim'
 *      labels: // value for 'labels'
 *      after: // value for 'after'
 *      myOwn: // value for 'myOwn'
 *   },
 * });
 */
export function useGetBettingGamesQuery(baseOptions?: Apollo.QueryHookOptions<GetBettingGamesQuery, GetBettingGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBettingGamesQuery, GetBettingGamesQueryVariables>(GetBettingGamesDocument, options);
      }
export function useGetBettingGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBettingGamesQuery, GetBettingGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBettingGamesQuery, GetBettingGamesQueryVariables>(GetBettingGamesDocument, options);
        }
export function useGetBettingGamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBettingGamesQuery, GetBettingGamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBettingGamesQuery, GetBettingGamesQueryVariables>(GetBettingGamesDocument, options);
        }
export type GetBettingGamesQueryHookResult = ReturnType<typeof useGetBettingGamesQuery>;
export type GetBettingGamesLazyQueryHookResult = ReturnType<typeof useGetBettingGamesLazyQuery>;
export type GetBettingGamesSuspenseQueryHookResult = ReturnType<typeof useGetBettingGamesSuspenseQuery>;
export type GetBettingGamesQueryResult = Apollo.QueryResult<GetBettingGamesQuery, GetBettingGamesQueryVariables>;